import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import {
  addClass,
  addClassWithFile,
  deleteClass,
  getClasses,
  updateClass,
  updateClassWithFile,
} from '../services/classService'
import type { ClassQueryParams } from '../services/classService'

// 查询班级列表（分页）
export function useClasses(params?: ClassQueryParams) {
  return useQuery({
    queryKey: ['classes', params],
    queryFn: () => getClasses(params),
    select: (data) => data.data,
  })
}

// 添加班级
export function useAddClass() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addClass,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classes'] })
      message.success('添加班级成功')
    },
    onError: (error: Error) => {
      message.error(`添加班级失败: ${error.message}`)
    },
  })
}

// 更新班级
export function useUpdateClass() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateClass,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classes'] })
      message.success('更新班级成功')
    },
    onError: (error: Error) => {
      message.error(`更新班级失败: ${error.message}`)
    },
  })
}

// 删除班级
export function useDeleteClass() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deleteClass,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classes'] })
      message.success('删除班级成功')
    },
    onError: (error: Error) => {
      message.error(`删除班级失败: ${error.message}`)
    },
  })
}

// 添加班级（支持文件上传）
export function useAddClassWithFile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addClassWithFile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classes'] })
      message.success('添加班级成功')
    },
    onError: (error: Error) => {
      message.error(`添加班级失败: ${error.message}`)
    },
  })
}

// 更新班级（支持文件上传）
export function useUpdateClassWithFile() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateClassWithFile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['classes'] })
      message.success('更新班级成功')
    },
    onError: (error: Error) => {
      message.error(`更新班级失败: ${error.message}`)
    },
  })
}
